import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      personal: {
        list_personal: {
          edit_admin: {
            main_title: 'MAIN_TITLE',
            name: 'NAME',
            email: 'EMAIL',
            ms_teams: 'MS_TEAMS',
            telegram: 'TELEGRAM',
            whatsapp: 'WHATSAPP',
            role: 'ROLE',
            status: 'STATUS',
            lock: 'LOCK',
            unlock: 'UNLOCK',
            status_description: 'STATUS_DESCRIPTION',
            save: 'SAVE',
            back: 'BACK',
            mfa_enabled_label: 'MFA_ENABLED_LABEL',
            mfa_enabled: 'MFA_ENABLED',
            mfa_disabled: 'MFA_DISABLED',
            modal_window: {
              title: 'TITLE',
              message: 'MESSAGE',
              answer_yes: 'ANSWER_YES',
              answer_no: 'ANSWER_NO',
            },
          },
        },
      },
    },
  }));
}
